import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const XCircleIcon = (p: IconProps) => <Icon {...p}><circle cx="12" cy="12" r="10" /><path d="m15 9-6 6" /><path d="m9 9 6 6" /></Icon>
